import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import {
  TAB_COLOR,
  TAB_LINK_ACTIVE_BORDER_BOTTOM,
  TAB_LINK_BORDER_BOTTOM,
  TAB_LINK_FOCUS_BORDER_BOTTOM,
  WRAPPER_BACKGROUND,
  WRAPPER_BORDER_BOTTOM,
  WRAPPER_BOX_SHADOW,
  WRAPPER_MARGIN,
} from './constants';

export const Wrapper = styled.div`
  background: ${WRAPPER_BACKGROUND};
  box-shadow: ${WRAPPER_BOX_SHADOW};
  border-bottom: ${WRAPPER_BORDER_BOTTOM};
  display: flex;
  flex-direction: row;
  height: 3rem;
  margin-bottom: ${WRAPPER_MARGIN};
  overflow-x: scroll;
  overflow-y: hidden;
  padding: 0;
  width: 100%;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
  }

  ${Styles.desktop`
    display: none;
  `}
`;

export const TabLink = styled(Link)<{ active?: boolean }>`
  text-decoration: none;
  font-family: ${Styles.fontFamily.base};
  text-align: center;
  text-transform: none;
  letter-spacing: normal;
  max-width: 100%;
  white-space: nowrap;
  outline: 0;
  cursor: pointer;
  margin: 0;
  display: block;

  border-bottom: ${TAB_LINK_BORDER_BOTTOM};
  color: ${TAB_COLOR};
  font-size: 1rem;
  height: 100%;
  padding: 0.5rem;
  transition: transform 200ms ease-out;
  font-weight: normal;
};

  ${({ active }) =>
    active &&
    css`
      border-bottom: ${TAB_LINK_ACTIVE_BORDER_BOTTOM};
      color: ${Styles.color.primary};
    `}

  &:active {
    transform: none;
    border-bottom: ${TAB_LINK_ACTIVE_BORDER_BOTTOM};
  }

  &:focus {
    transform: none;
    border-bottom: ${TAB_LINK_FOCUS_BORDER_BOTTOM};
  }
`;
